import Axios from "axios";
import Swal from 'sweetalert2';

const tablas = [
  { nombre:'Materias', tabla:'materias', seleccion:true, url:'/api/tablasgenerales/materias' },
  { nombre:'Países', tabla:'paises', seleccion:true, url:'/api/tablasgenerales/paises' },
  { nombre:'Provincias', tabla:'provincias', seleccion:true, url:'/api/tablasgenerales/provincias/all' },
  { nombre:'Nacionalidades', tabla:'nacionalidades', seleccion:true, url:'/api/tablasgenerales/nacionalidades' },
  { nombre:'Instrumentos', tabla:'instrumentos', seleccion:true, url:'/api/tablasgenerales/instrumentos' },
  { nombre:'Niveles instrumental', tabla:'nivelesi', seleccion:true, url:'/api/tablasgenerales/nivelesi' },
  { nombre:'Niveles ensamble', tabla:'nivelese', seleccion:true, url:'/api/tablasgenerales/nivelese' },
  { nombre:'Carreras', tabla:'carreras', seleccion:true, url:'/api/tablasgenerales/carreras' }
];

const actualizarCache = async () => {

  const respuestas = await Promise.all(
    tablas.map(t => Axios.get(t.url))
  );

  respuestas.forEach((resp, index) => {
    const tabla = tablas[index].tabla;
    localStorage.setItem(tabla, JSON.stringify(resp.data));
  });
};

export const sincronizarCacheTablas = async () => {

  let loadingOpen = false;

  try {

    const resp = await Axios.get('/api/tablasgenerales/cacheversion');
    const versionBackend = resp.data.version;

    const versionLocal = localStorage.getItem('cacheversion');

    if (versionLocal && versionLocal === versionBackend) {
      return;
    }

    // Aviso de inicio
    Swal.fire({
      title: 'Actualizando catálogos',
      html: 'Se está actualizando la información. Espere por favor...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      timer: 6000,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    loadingOpen = true;

    await actualizarCache();

    localStorage.setItem('cacheversion', versionBackend);

    // Éxito
    setTimeout(() => {
            Swal.fire({
      icon: 'success',
      title: 'Actualización completada',
      html: 'La cache de tablas se actualizó correctamente',
      timer: 1800,
      showConfirmButton: false
    });     
    }, 6000);


  } catch (err) {

    console.error('Error sincronizando cache', err);

    if (loadingOpen) {
      Swal.close();
    }

    Swal.fire({
      icon: 'error',
      title: 'Error al actualizar la cache',
      html: 'No se pudo actualizar la información. Intente nuevamente.',
      confirmButtonColor: '#3085d6'
    });
  }
};
